module.exports = __webpack_public_path__ + "static/media/logo_tr.2af53b34.png";